import { computed, ref } from 'vue';
import { getJackpotFeature } from '@/api/jackpot';

/**
 * Jackpot kill-switch for C 端（v1.3）。
 * - Build-time: VUE_APP_JACKPOT_ENABLED
 * - Runtime: GET /jackpot/feature → enabled + publicRoundV2
 */
const envAllows = String(process.env.VUE_APP_JACKPOT_ENABLED ?? 'false').toLowerCase() === 'true';

const serverEnabled = ref(false);
const publicRoundV2 = ref(false);
const loaded = ref(false);
let inflight = null;

export async function refreshJackpotFeature() {
  if (!envAllows) {
    serverEnabled.value = false;
    publicRoundV2.value = false;
    loaded.value = true;
    return false;
  }
  if (inflight) return inflight;
  inflight = (async () => {
    try {
      const data = await getJackpotFeature();
      serverEnabled.value = !!data?.enabled;
      publicRoundV2.value = !!(data?.enabled && data?.publicRoundV2);
    } catch {
      serverEnabled.value = false;
      publicRoundV2.value = false;
    } finally {
      loaded.value = true;
      inflight = null;
    }
    return serverEnabled.value;
  })();
  return inflight;
}

/** 是否已完成至少一次 feature 探测（成功或失败） */
export function isJackpotFeatureLoaded() {
  return loaded.value;
}

/** 同步读取当前开关（须在 loaded 后使用） */
export function isJackpotFeatureEnabledSync() {
  return envAllows && serverEnabled.value;
}

export function useJackpotFeature() {
  if (!loaded.value && envAllows) {
    refreshJackpotFeature();
  }
  const enabled = computed(() => envAllows && serverEnabled.value);
  return { enabled, publicRoundV2, loaded, refreshJackpotFeature };
}

export function isJackpotEnvAllowed() {
  return envAllows;
}

/** 同步读 publicRoundV2（大厅/详情解析用；未 refresh 前为 false） */
export function getJackpotPublicRoundV2() {
  return publicRoundV2.value;
}
